import { Roles } from '@/auth/enum/auth.enum';
import { AuthService } from '@/auth/service/auth.service';
import { ApprovalApproveContractOwner } from '@/interfaces/approvals/approvals';
import { FilterList, Person } from '@/interfaces/person';
import { Manager } from '@/interfaces/requirement';
import { ApprovalsService } from '@/services/approvals/approvals.service';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { ofuscate } from '@/utils/obfuscation';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-approve-request[virtualRole]',
  templateUrl: './approve-request.component.html',
  styleUrls: ['./approve-request.component.css', '../../approve.component.css'],
})
export class ApproveRequestComponent implements OnInit {
  @Input() assetId?: number;
  @Input() selectedPersonEmail?: string;
  @Input() requirementId?: number;
  @Input() virtualRole: Roles = '';
  @Output() goBack = new EventEmitter();

  formGroup: FormGroup = new FormGroup({
    superintendentId: new FormControl(0),
    superintendentMdmid: new FormControl(''),
    superintendentText: new FormControl(),
    managerId: new FormControl(0, [Validators.required, Validators.min(1)]),
  });

  formGroupEmployeeControl = new FormGroup({
    managerFormControl: new FormControl(''),
    superintendentFormControl: new FormGroup({
      filterText: new FormControl(''),
      id: new FormControl(0),
      mdmid: new FormControl(''),
    }),
  });

  selectedSuperintendent?: FilterList[0];

  get superintendentFormControl(): FormControl {
    return this.formGroup.controls.superintendentId as FormControl;
  }
  get superintendentFormControlText(): FormControl {
    return this.formGroup.controls.superintendentText as FormControl;
  }
  get managerFormControl(): FormControl {
    return this.formGroup.controls.managerId as FormControl;
  }

  listSuperintendentOptions: FilterList = [];
  loadingPersonOptions: boolean = false;

  listManager: Manager[] = [];

  loggedPerson?: Person;

  constructor(
    private serviceApprovals: ApprovalsService,
    private store: Store<StoreState>,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (loggedPerson) => {
        this.loggedPerson = loggedPerson;
      },
    });

    const formControls = this.formGroupEmployeeControl.controls;
    (formControls.superintendentFormControl as FormGroup).valueChanges.subscribe({
      next: ({ id, mdmid }) => {
        this.formGroup.patchValue({ superintendentId: id, superintendentMdmid: mdmid });
      },
    });
    formControls.managerFormControl.valueChanges.subscribe({
      next: (managerId) => {
        this.formGroup.patchValue({ managerId });
      },
    });
  }

  ngOnInit(): void {

  }

  onGoBack() {
    this.goBack.emit('');
  }

  onSubmit() {
    const { managerId, superintendentMdmid } = this.formGroup.value;
    if (this.formGroupEmployeeControl.valid) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro que quieres aprobar esta solicitud?',
        text: 'La solicitud será aprobada automáticamente si continúa en Aprobar Solicitud.',
        text2: 'Presiona volver para regresar a la pantalla anterior.',
        acceptButtonText: 'Aprobar Solicitud',
        actionOnAccept: () => {
          if (this.requirementId && this.loggedPerson) {
            const params: ApprovalApproveContractOwner = {
              actionType: 3,
              updaterMdmid: this.loggedPerson.mdmid,
              requirementId: this.requirementId,
              approveSuperintentMdmid: superintendentMdmid,
              updaterRole: this.auth.getMyRole().id,
              approveRequestManager: managerId,
            };
            // primer dispatch
            this.store.dispatch(loaderAnimationShow());
            this.serviceApprovals.approveApprovalContractOwner(params, this.virtualRole)
              .subscribe({
                next: (res) => {
                  const ofuscatedData = ofuscate({ email: this.selectedPersonEmail });
                  this.router.navigate(['approved', ofuscatedData], { relativeTo: this.route });
                },
                error: () => {
                  this.store.dispatch(loaderAnimationHide());

                  this.store.select('pageError').subscribe({
                    next: (pageConfig) => {
                      const [website, ...url] = window.location.href.split('//')[1].split('/');
                      if (pageConfig.errorType !== 'Mulesoft') {

                        const ofuscatedData = ofuscate({ variant: 'failure' });
                        this.router.navigate(['approved', ofuscatedData], { relativeTo: this.route });

                      }
                    },
                  });
                },
                complete: () => {
                  // segundo dispatch
                  this.store.dispatch(loaderAnimationHide());
                },
              });
          }
        },
      }));
    }
  }
}
